import { type FC, type HTMLAttributes } from 'react';
import cn from 'classnames';

interface MiniTimerProps extends HTMLAttributes<HTMLDivElement> {
  time: string;
}

const MiniTimer: FC<MiniTimerProps> = ({ time, ...props }) => {
  return (
    <div
      {...props}
      className={cn(
        '-mt-2 h-6 text-accent min-w-16 rounded-full bg-black/60 backdrop-blur-2xl flex items-center justify-center text-xs font-bold shadow-glass-blur',
        props.className,
      )}
    >
      {time}
    </div>
  );
};

export { MiniTimer };
